import React, { Fragment, useState } from 'react'
import Header from './Header'
import Sidebar from './Sidebar'
import { Outlet } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { setToggle } from '../../redux/reducers/settingsReducers'

const Layout = () => {

  const toggle = useSelector(state => state.settings.toggle)

  return (
    <Fragment>
      <Sidebar />
      <div className={`${toggle?"ml-[270px]":"ml-[80px]"} max-[768px]:ml-0`}>
        <Header />
      </div>
      <div className={`${toggle?"ml-[270px]":"ml-[80px]"} p-7 max-[410px]:p-0 max-[768px]:ml-0`}>
        <div className='w-full max-[410px]:p-3  text-[14px]'>
            <Outlet />
        </div>
      </div>
    </Fragment>
  )
}

export default Layout